import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import './Table.module.scss'

const propTypes = {
  /**
   * Input placeholder
   */
  placeholder: PropTypes.string,
  /**
   * Callback fired when using the input and pass the following arguments: value (string)
   */
  onChange: PropTypes.func.isRequired,
  /**
   * If not undefined, will control the field value
   */
  remoteValue: PropTypes.string,
  /**
   * Used to get the 'onChange' func of the filter
   */
  getFilter: PropTypes.func,
}

function TextFilter(props) {
  const { remoteValue = undefined, onChange, placeholder = '', getFilter = () => {} } = props ?? {}
  const [value, setValue] = useState('')

  useEffect(() => {
    if (remoteValue !== undefined) {
      setValue(remoteValue ?? '')
    }
  }, [remoteValue])

  const internalOnChange = (val) => {
    setValue(val)
    onChange(val)
  }

  useEffect(() => {
    if (getFilter) {
      getFilter(internalOnChange)
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Form.Control
      size="sm"
      type="text"
      className={clsx('Uic-Table-input', 'Uic-Table-textFilter')}
      placeholder={placeholder}
      onClick={(event) => event.stopPropagation()}
      value={value}
      onChange={(event) => {
        const newValue = event.target.value
        internalOnChange(newValue)
      }}
    />
  )
}

TextFilter.propTypes = propTypes

export default TextFilter
